// Generiert aus scripts/i18n-pending-sources.json; nur durch den Manifest-Helfer aktualisieren.
export const PENDING_SOURCE_KEYS: readonly string[] = [];
export const PENDING_SOURCE_TEXTS: Record<"de" | "en", Record<string, string>> = {
  "de": {},
  "en": {}
};
